var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Grid, { GridColumn } from '@telia-front/grid';
import Image from '@telia-front/image';
import Tag from '@telia-front/tag';
const HeaderMegamenuBanner = (props) => {
    const { background, tag, image, children, className } = props, rest = __rest(props, ["background", "tag", "image", "children", "className"]);
    const BEM = () => {
        const classArray = ['header__megamenu-banner'];
        if (background) {
            classArray.push('header__megamenu-banner--with-background');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const renderContent = () => {
        return (React.createElement(React.Fragment, null,
            tag && React.createElement(Tag, Object.assign({}, tag, { size: "tiny" })),
            React.createElement("div", null, children)));
    };
    const renderImageGrid = () => {
        return (React.createElement(Grid, { noWrap: true, align: ['middle-xs'] },
            image && (React.createElement(GridColumn, { width: ['min'] },
                React.createElement(Image, Object.assign({}, image)))),
            React.createElement(GridColumn, { width: ['max'] }, renderContent())));
    };
    return (React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: BEM() }),
        React.createElement("div", { className: "header__megamenu-banner-inner" },
            React.createElement("div", { className: "header__megamenu-banner-content" }, image ? renderImageGrid() : renderContent()),
            background && (React.createElement("div", { className: "header__megamenu-banner-background" },
                React.createElement("div", { className: "header__megamenu-banner-background-inner" },
                    React.createElement("div", { className: "header__megamenu-banner-background-image-wrapper" },
                        React.createElement(Image, Object.assign({}, background, { className: "header__megamenu-banner-background-image" })))))))));
};
export default HeaderMegamenuBanner;
